export enum ERouteName {
    Admin = 'admin',
    Configurator = 'configurator',
    ConfiguratorAdmin = 'configuratorAdmin',
    ConfiguratorAdminTemplate = 'configuratorAdminTemplate',
    ConfiguratorTemplate = 'configuratorTemplate',
    Login = 'login',
    ProductSelection = 'productSelection',
}
